import { Client } from "app/models/client";
import { Location } from "app/models/location";
import { PlannedServiceWork } from "app/models/plannedServiceWork";
import { PlannedServicePhotoData } from "./plannedServicePhotoData";
import { ServiceObject } from "./serviceObject";

export class PlannedService {

  public id: number;
  public name: string;
  public serviceObject: ServiceObject;
  public status: PlannedService.Status;
  public works: PlannedServiceWork[];
  public photos: PlannedServicePhotoData[];
  public finishDate?: Date;
  public deadline: Date;
  public client: Client;
}

export namespace PlannedService {

  export enum Status {
    Planned,
    Done,
    Canceled
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/plannedService.ts